import { secureGet } from "../Config/ApiConfig";

let cachedPolicy = null;
let inFlight = null;
let lastFetchedAt = 0;
const POLICY_TTL_MS = 5 * 60 * 1000; // 5 minutes

export const getFileUploadPolicy = async (forceRefresh = false) => {
    const now = Date.now();
    if (!forceRefresh && cachedPolicy && (now - lastFetchedAt) < POLICY_TTL_MS) {
        return cachedPolicy;
    }
    if (inFlight) return inFlight;
    inFlight = (async () => {
        try {
            const { data } = await secureGet('/file-uploads/policy');
            cachedPolicy = data;
            lastFetchedAt = Date.now();
            return cachedPolicy;
        } finally {
            inFlight = null;
        }
    })();
    return inFlight;
};

export const getExtension = (filename) => {
    if (!filename || typeof filename !== 'string') return '';
    const lastDot = filename.lastIndexOf('.');
    if (lastDot <= 0 || lastDot === filename.length - 1) return '';
    return filename.slice(lastDot + 1).toLowerCase();
};

export const getAcceptFromPolicy = (policy) => {
    const exts = Array.isArray(policy?.allowed_extensions) ? policy.allowed_extensions : [];
    if (!exts.length) return '';
    return exts.map((ext) => `.${String(ext).toLowerCase()}`).join(',');
};

export const formatBytes = (bytes) => {
    try {
        if (typeof bytes !== 'number' || isNaN(bytes)) return '';
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const value = (bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 2);
        return `${value} ${sizes[i]}`;
    } catch (_) {
        return '';
    }
};

export const validateFileAgainstPolicy = (file, policy) => {
    if (!file) return { valid: false, code: 'no_file' };
    const p = policy || {};
    const allowed = Array.isArray(p.allowed_extensions) ? p.allowed_extensions.map((e) => String(e).toLowerCase()) : [];
    const maxSize = typeof p.max_file_size_bytes === 'number' ? p.max_file_size_bytes : undefined;
    const maxName = typeof p.max_filename_length === 'number' ? p.max_filename_length : undefined;

    const name = file.name || '';
    const ext = getExtension(name);
    if (allowed.length && (!ext || !allowed.includes(ext))) {
        return { valid: false, code: 'extension', details: { allowed } };
    }
    if (typeof file.size === 'number' && typeof maxSize === 'number' && file.size > maxSize) {
        return { valid: false, code: 'size', details: { maxSize } };
    }
    if (typeof maxName === 'number' && name && name.length > maxName) {
        return { valid: false, code: 'name', details: { maxName } };
    }
    return { valid: true };
};

















